interface SemverParts {
    major: number;
    minor: number;
    patch: number;
}

export const isNewerVersion = (remoteVersion: string, currentVersion: string): boolean => {
    const remote = parseSemver(remoteVersion);
    const current = parseSemver(currentVersion);

    if (remote.major !== current.major) {
        return remote.major > current.major;
    }
    if (remote.minor !== current.minor) {
        return remote.minor > current.minor;
    }
    return remote.patch > current.patch;
};

const parseSemver = (version: string): SemverParts => {
    const clean = version.replace(/^v/, '').split('-')[0];
    const [major, minor, patch] = clean.split('.').map(Number);

    return { major: major || 0, minor: minor || 0, patch: patch || 0 };
};
